import type {MediaItemType} from '@sdox/ui'
import type {XcMediaRefFragment} from '@sdox/api'

export const xcMediaRefToMediaItem = (media: XcMediaRefFragment): MediaItemType => {
  if (media.mimeType?.startsWith('video')) {
    return {
      type: 'video',
      videoSrc: media.fileUrl,
      thumbnail: media.thumbnailUrl,
    }
  }

  return {
    type: 'image',
    image: {
      src: media.thumbnailUrl,
      placeholderSrc: media.thumbnailUrl380w,
      alt: media.altText ?? '',
      width: media.originalThumbnailDimensions?.width,
      height: media.originalThumbnailDimensions?.height,
    },
  }
}
